import React from 'react';
import { ArrowRight } from 'lucide-react';
export function ServicesGrid() {
  const services = [{
    title: 'Car Detailing',
    description: 'Full interior and exterior detailing for sedans, coupes, and sports cars.',
    image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/7c0625ad-2336-4c80-a3b8-91d654578d46/phoenix-vehicle-detailing.jpg'
  }, {
    title: 'RV Detailing',
    description: 'Comprehensive cleaning and oxidation removal for recreational vehicles.',
    image: 'https://cdn.magicpatterns.com/uploads/5E1UosECj4FfK1fK3CXUEL/RV-Exterior-Detailing-Phoenix-AZ.jpeg.webp'
  }, {
    title: 'Boat Detailing',
    description: 'Hull cleaning, polishing, and interior detailing for all watercraft.',
    image: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/22aca4f4-9c74-4e4e-bade-f1a891578108/Boat-Detailing-2-After-Square.jpg'
  }, {
    title: 'Aircraft Detailing',
    description: 'Specialized detailing services for private planes and helicopters.',
    image: 'https://cdn.magicpatterns.com/uploads/jQdEZGjbRxvAuLUK9MpLCc/Aircraft-Detailing-Phoenix-1536x1536.jpg.webp'
  }, {
    title: 'Motorcycle Detailing',
    description: 'Meticulous cleaning for cruisers, sport bikes, and custom choppers.',
    image: 'https://cdn.magicpatterns.com/uploads/eqHF22EYaBBqgL8oKa36jF/Motorcycle-Detailing-Service-Phoenix-AZ.jpeg.webp'
  }, {
    title: 'Fleet Detailing',
    description: 'Regular maintenance plans for corporate and rental fleets.',
    image: 'https://cdn.magicpatterns.com/uploads/d4L7R1y4K7tVf5FSjHAnrd/fleet-detailing-metro-phoenix.jpeg.webp'
  }];
  return <section id="services" className="py-20 md:py-32 bg-[#111111]" data-id="element-225">
      <div className="container mx-auto px-4 md:px-6" data-id="element-226">
        <div className="mb-16" data-id="element-227">
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase mb-4" data-id="element-228">
            Expert Detailing for Every Vehicle
          </h2>
          <div className="w-24 h-1 bg-[#7FD4D4]" data-id="element-229"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-230">
          {services.map((service, index) => <div key={index} className="group bg-[#1A1A1A] border border-white/10 overflow-hidden rounded-sm hover:border-[#7FD4D4]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#7FD4D4]/10" data-id="element-231">
              <div className="h-56 overflow-hidden relative" data-id="element-232">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" data-id="element-233"></div>
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-234" />
              </div>
              <div className="p-8" data-id="element-235">
                <h3 className="text-2xl font-bold text-white mb-3 font-montserrat" data-id="element-236">
                  {service.title}
                </h3>
                <p className="text-white/60 mb-6 font-inter h-12" data-id="element-237">
                  {service.description}
                </p>
                <a href="#booking" className="inline-flex items-center text-[#7FD4D4] font-bold uppercase tracking-wide text-sm group-hover:text-white transition-colors" data-id="element-238">
                  Learn More{' '}
                  <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-239" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}